var map = {
	"./2024-img-articolo-dicembre1.jpg": 24681,
	"./2024-img-articolo-dicembre2-1.jpg": 31683,
	"./2024-img-articolo-dicembre2.jpg": 16149,
	"./2024-img-articolo-novembre1.jpg": 5914,
	"./2024-img-articolo-novembre2.jpg": 25039,
	"./2025-img-articolo-febbraio1.jpg": 96231,
	"./2025-img-articolo-febbraio2.jpg": 12392,
	"./2025-img-articolo-gennaio1.jpg": 37954,
	"./2025-img-articolo-gennaio2.jpg": 40684,
	"./2025-img-articolo-marzo1.jpg": 75008,
	"./2025-img-articolo-marzo2.jpg": 51861,
	"./2025-real-time-data.jpg": 82913,
	"./5-applicazioni-machine-learning-aziende.jpg": 25252,
	"./L'Architettura-a-Microservizi.jpg": 74044,
	"./PWAs-VS-APPN.jpg": 23062,
	"./Progressive-Web-Apps.jpg": 16805,
	"./Uso-del-Cloud.jpg": 24786,
	"./accessibilita-inclusivita-sviluppo-software-custom.jpg": 16628,
	"./agentic-ai-trasformazione-digitale-2025.png": 78271,
	"./agile-development-orangeloop.jpg": 24048,
	"./agile-devops.jpg": 97007,
	"./ai-coding-competences-tools-training.jpg": 76965,
	"./ai-powered-development.png": 99753,
	"./angular-sviluppo-custom.jpg": 98845,
	"./angular-vue-flutter-quale-scegliere-app-personalizzate.jpg": 49046,
	"./api-first-architettura-sistemi-flessibili.jpg": 82760,
	"./app-cross-platform-vantaggi-per-aziende-orangeloop.jpg": 50377,
	"./app-mobile-custom-vantaggi-svantaggi.jpg": 2306,
	"./app-native-ibride-web-vantaggi-svantaggi.jpg": 82202,
	"./applicazioni-ar-vr-ecommerce.jpg": 19794,
	"./applicazioni-cross-platform-vantaggi-per-aziende-orangeloop.jpg": 57833,
	"./architettura-micro-frontend-enterprise-scalabilita-manutenibilita-autonomia.jpg": 36777,
	"./astrorei-come-migliorare-lavoro-da-remoto-consigli-per-developers.jpg": 90021,
	"./astrorei-sviluppo-software-in-outsourcing-quale-modalità-scegliere.jpg": 92359,
	"./automazione-ai-smart-contract.png": 24721,
	"./backend-per-iot.jpg": 15120,
	"./big-data-business-intelligence-sfruttare-i-dati.jpg": 62060,
	"./blockchain-contratti-digitali-aziende.jpg": 61784,
	"./business-intelligence-data-analysis-cover.jpg": 21775,
	"./business-intelligence-data-analysis.jpg": 32129,
	"./chatgpt-python.jpg": 70546,
	"./ci-cd-intelligente-machine-learning-1.jpg": 92228,
	"./ci-cd-intelligente-machine-learning.jpg": 58333,
	"./creare-connessioni-importanza-network.jpg": 74899,
	"./creare-mvp-vincente.jpg": 21886,
	"./cultura-aziendale-positiva.jpg": 31714,
	"./developer-experience-platform-engineering-astrorei-produttivita-retention.jpg": 69075,
	"./devops-i-vantaggi-nello-sviluppo.jpg": 96557,
	"./devsecops-sicurezza-nello-sviluppo.png": 26938,
	"./differenza-backend-frontend-fullStack-iceberg.jpg": 92534,
	"./explainable-ai-2025-1.jpg": 66119,
	"./fasi-della-metodologia-devops-orangeloop.jpg": 21706,
	"./feature-flags-progressive-delivery-rilasci-incrementali-sicuri-astrorei.jpg": 54197,
	"./finops-aziende-crescita-governance-cloud-cost-optimization-innovazione.jpg": 57381,
	"./flessibilita-sul-lavoro.jpg": 52970,
	"./flutter-sviluppo-custom.jpg": 15516,
	"./formazione-aziendale-perche-e-importante.jpg": 44221,
	"./frontend-backend-full-stack-developer-differenze-orangeloop.jpg": 89332,
	"./governance-mlops-pmi-monitoraggio-sicurezza-compliance.jpg": 16167,
	"./hackathon-cose-come-funziona-per-sviluppatori-astrorei.jpg": 17728,
	"./human-augmentation.jpg": 47588,
	"./img-articolo-ottobre1.jpg": 85594,
	"./img-articolo-ottobre2.jpg": 34856,
	"./img_articolo_settembre1.jpg": 62923,
	"./img_articolo_settembre2.jpg": 15668,
	"./implementare-blockchain.jpg": 7530,
	"./ingegneria-software-sostenibile-strategie-green-cto-team-it.jpg": 79224,
	"./lifelong-learning-programmatori-cos'è-perché-Importante.jpg": 22640,
	"./low-code-development-cose-vantaggi-migliori-piattaforme.jpg": 77702,
	"./low-code_Astrorei.jpg": 31930,
	"./metaverso-cosa-rappresenta-per-gli-sviluppatori-orangeloop.jpg": 69859,
	"./migliori-framework-app-cross-platform-orangeloop.jpg": 89380,
	"./migliori-strumenti-per-business-intelligence.jpg": 82886,
	"./minimum-viable-product-come-puo-ridurre-rischi-azienda-astrorei.jpg": 63555,
	"./modernizzare-business-intelligence-pmi-data-mesh-vs-data-warehouse.jpg": 21926,
	"./mvp-minimum-viable-product-cos-e-perche-e-fondamentale-orangeloop.jpg": 10194,
	"./observability-cloud-native-serverless-applications.jpg": 91587,
	"./orangeloop-analisi-dati-come-prendere-decisioni-aziendali-strategiche.jpg": 48222,
	"./orangeloop-big-data-analytics-come-migliorare-performance-applicazioni-aziendali.jpg": 99767,
	"./orangeloop-code-refactoring-nell-agile-tutti-i-vantaggi.jpg": 21862,
	"./orangeloop-intelligenza-artificiale-sviluppo-software.jpg": 68857,
	"./orangeloop-migliorare-life-work-balance-guida-per-sviluppatori.jpg": 11442,
	"./orangeloop-migliore-ide-python-come-sceglierlo.jpg": 41619,
	"./orangeloop-sviluppo-in-outsourcing-vantaggi-aziende.png": 52498,
	"./outsourcing-o-sviluppo-in-house-quale scegliere.jpg": 38412,
	"./perche-scegliere-sviluppo-software-personalizzato.jpg": 96256,
	"./post-quantum-cryptography-dati-qubit-crittografia.png": 14391,
	"./post-quantum-cryptography-dati-qubit.png": 6334,
	"./pwa-trend-sviluppo-software.jpg": 93862,
	"./pwa-vs-native.jpg": 95866,
	"./pycharm-cose-perche-sceglierlo.jpg": 17804,
	"./quantum-computing-software-ai-2025.jpg": 2740,
	"./resilience-software-sistemi-business-critical-architettura-recovery-observability.jpg": 56584,
	"./serverless-vantaggi-svantaggi.jpg": 66561,
	"./sprint_metodologia_di_sviluppo_agile_orangeloop.jpg": 96498,
	"./stackoverflow-2023.png": 6309,
	"./step-selezione-astrorei.jpg": 44572,
	"./sviluppare-con-react-vantaggi-aziende-orangeloop.jpg": 82322,
	"./sviluppo-low-code-trasformazione-digitale.jpg": 67078,
	"./sviluppo-software-10-trend-2024.jpg": 21696,
	"./system-integration-perche-importante-per-aziende-orangeloop.jpg": 84039,
	"./team-working-azienda-perche-importante.jpg": 16034,
	"./tecnologia-blockchain.jpg": 81550,
	"./ten-growing-trends-part-2.jpg": 50075,
	"./tipologie-app-in-node-js.png": 91447,
	"./ux-ui-and-programming-development-technology.jpg": 38131,
	"./vue-sviluppo-custom.jpg": 74746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9773;